import React, { useEffect, useRef } from "react";
import { func, array, bool } from "prop-types";
import { Formik, Form } from "formik";
import { Col, Row, CardBody } from "reactstrap";
import { LabeledInput } from "../../../../components/formik";
import { ButtonWithSpinner } from "../../../../components/common";
import "./loginForm.css";

const LoginRuleForm = ({ handleSubmit, isLoading }) => {
  const formRef = useRef(null);

  useEffect(() => {
    const callBackEnterListener = (e) => {
      if (e.key === "Enter" && formRef.current) {
        formRef.current.handleSubmit();
      }
    };
    
    window.addEventListener("keydown", callBackEnterListener);

    return () => {
      window.removeEventListener("keydown", callBackEnterListener);
    };
  }, []);

  return (
    <Formik ref={formRef} onSubmit={handleSubmit} enableReinitialize>
      <Form className="login-user-oidc-form">
        <Row>
          <Col sm="12" md={{ size: 8, offset: 2 }}>
            <div className="login-form-container">
              <div>
                <CardBody>
                  <Row>
                    <Col sm="12">
                      <LabeledInput placeholder="Username" name="UserInput" />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12" className="d-flex justify-content-center mt-3">
                      <ButtonWithSpinner
                        className="login-button"
                        text="Sign In"
                        outline
                        type="submit"
                        loading={isLoading}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </div>
            </div>
          </Col>
        </Row>
      </Form>
    </Formik>
  );
};
LoginRuleForm.propTypes = {
  handleSubmit: func.isRequired,
  organizations: array,
  isLoading: bool,
};
export default LoginRuleForm;



// WEBPACK FOOTER //
// ./src/features/login/components/login-oidc-form/LoginRuleForm.jsx